import { RICHTEXT_TYPE } from './constants/content'

export const isAsset = field => !!(field?.assetType && field.assetId)
export const isEntry = field => !!(field?.contentType && field.contentId)
export const isRichTextPart = part => !!part?.value &&
  [RICHTEXT_TYPE.ASSET, RICHTEXT_TYPE.CONTENT, RICHTEXT_TYPE.TEXT].includes(part.type) &&
  Object.keys(part).length === 2
export const isRichTextField = field => Array.isArray(field) && field.every(isRichTextPart)
